module.exports = {
  "chat.end":"Tīmataria anō tō kōrerorerorero",
  "chat.endall":"Whakamutua te Korero",
  "chat.cancel":"Whakakore",
  "chat.cookie":"Ma tenei kaiawhina mamati e whakamahi nga pihikete kia pai ai to wheako",
  "chat.learn":"Ako atu",
  "chat.minimize":"Whakaiti",
  "chat.hide":"Katia",
  "chat.hidebot.text":"Kati ka ngaro te avatar mo te 15 meneti",
  "chat.hidebot":"Katia Bot",
  "chat.restart":"Tīmata anō",
  "switch.language":"Whakawhiti Reo",
  "switch.property":"whakawhiti taonga",
  "restart.converstation":"Tīmataria anō te Whakawhitiwhiti",
  "chat.endtext":"Kei te tino hiahia koe ki te whakamutu i te korerorero onāianei?",
  "check.availabity":"Tirohia te waatea",
  "check.availabity.submit":"Tukuna",
  "check.availabity.cancel":"Whakakore",
  "check.availabity.adults":"Nga pakeke (13+)",
  "check.availabity.children":"Tamariki",
  "check.availabity.child.age":"Tau - Tamariki",
  "feedback.leave":"Waiho Urupare",
  "feedback.leave.message":"Waiho Karere",
};
